import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    checkFormSubtitle: 'Check your proof of accommodation',
    description:
      'Since you don’t have a proof of address to your name, we are legally required to ask you for a proof of accommodation signed by your host.',
    downloadFormDescription:
      'You can print, fill and upload the following proof of accommodation template:',
    downloadFormLink: 'Download the template',
    downloadFormSubtitle: 'Fill your proof of accommodation',
    next: 'Continue',
    title: 'Proof of accommodation',
    uploadedDocumentName: 'Proof of accommodation document',
    uploadFormSubtitle: 'Upload the signed document',
  },
  fr: {
    checkFormSubtitle: 'Vérifiez votre attestation d’hébergement',
    description:
      'Vous n’avez pas de justificatif de domicile à votre nom\u00A0; nous devons donc vous demander une attestation d’hébergement signée par votre hébergeur.',
    downloadFormDescription: 'Vous pouvez utiliser le modèle suivant\u00A0: ',
    downloadFormLink: 'Télécharger le modèle',
    downloadFormSubtitle: 'Complétez votre attestation d’hébergement',
    next: 'Continuer',
    title: 'Attestation d’hébergement',
    uploadedDocumentName: 'Attestation d’hébergement',
    uploadFormSubtitle: 'Téléchargez l’attestation une fois signée',
  },
} as const);

export default locales;
